import React, { useMemo, useState, useEffect } from 'react';
import { Row, Col, Button } from 'reactstrap';

import ControldocDataTable from '../../controldoc/datatable';
import { riskLevelBadge, evidenceFileAasmStateBadge } from '../helper';

const ComplianceEvidenceTable = (props) => {
  const {
    complianceContextId,
    data: {
      riskLevelOptions,
    },
  } = props;

  const defaultRequestParams = { compliance_context_id: complianceContextId }

  const [selectedColumns, setSelectedColumns] = useState([]);
  const [selectedColumnKeys, setSelectedColumnKeys] = useState([]);
  const [selectedEvidences, setSelectedEvidences] = useState([]);

  useEffect(() => {
    if (tableColumns) {
      let visibleColumns = _.reject(tableColumns, {'hidden': true});

      setSelectedColumns(visibleColumns);
      setSelectedColumnKeys( _.map(visibleColumns, 'field') );
    }
  }, []);

  const onColumnSelectionChange = (e) => {
    const newSelectedColumnKeys = e.value;
    const filteredColumns = _.filter(tableColumns, column => { return _.includes(newSelectedColumnKeys, column.field) })

    setSelectedColumns(filteredColumns);
    setSelectedColumnKeys(newSelectedColumnKeys);
  }

  const onSelectionChange = selectedRecords => {
    setSelectedEvidences(selectedRecords);
  }

  const tableColumnsDefault = [
    {
      field: 'name',
      header: I18n.t('activerecord.attributes.compliance/evidence.name'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el nombre de la evidencia',
        filterrific: { search: 'search_by_name' }
      },
      sort: {
        enabled: true,
        filterrific: { sort: 'name' }
      }
    },
    {
      field: 'activity.name',
      header: I18n.t('activerecord.models.compliance/activity.one'),
      body: (row) => row?.activity?.name || I18n.t('no_entry'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el nombre de la actividad',
        filterrific: { search: 'search_by_activity_name' }
      },
      sort: {
        enabled: true,
        filterrific: { sort: 'activity.name_' }
      }
    },
    {
      field: 'risk_level.name',
      header: I18n.t('activerecord.models.compliance/risk_level.one'),
      body: (row) => riskLevelBadge(row?.activity?.risk_level),
      filter: {
        enabled: true,
        inputType: 'simple_select',
        placeholder: 'Selecciona un nivel de riesgo',
        options: riskLevelOptions,
        filterrific: { search: 'by_risk_level_id' }
      },
      sort: {
        enabled: true,
        filterrific: { sort: 'risk_level.value_' }
      }
    },
    {
      field: 'aasm_state',
      header: I18n.t('activerecord.attributes.compliance/evidence_file.aasm_state.one'),
      body: (row) => evidenceFileAasmStateBadge(row),
      sort: {
        enabled: true,
        filterrific: { sort: 'evidence_file.aasm_state' }
      }
    }
  ];

  const tableColumnsActions = [
    {
      field: 'actions',
      header: I18n.t('actions.actions'),
      body: (row) => {
        return row.policy.show && (
          <Button color="primary" outline size="sm" className="ml-2" href={Routes.compliance_evidence_path(row.id, { ...defaultRequestParams })}>
            {I18n.t('actions.show')}
          </Button>
        )
      }
    }
  ];

  const tableColumns = useMemo(() => {
    let columns = _.concat(
      tableColumnsDefault,
      tableColumnsActions
    )

    return _.compact(columns)
  }, [])

  return (
    <Row>
      <Col md="12">
        <ControldocDataTable
          columns={selectedColumns}
          configuration={{
            showDistributionListFilter: false,
            showGridlines: true,
            context: 'compliance',
            fetchRecords: {
              endpoint: Routes.compliance_evidences_path,
              keyName: 'evidences',
              defaultRequestParams: defaultRequestParams
            },
            selectable: {
              enabled: true,
              mode: 'multiple',
              selection: selectedEvidences,
              onSelectionChange: onSelectionChange
            },
            columnSelectable: {
              enabled: true,
              columns: tableColumns,
              selection: selectedColumnKeys,
              onSelectionChange: onColumnSelectionChange,
            }
          }}
        />
      </Col>
    </Row>
  );
};

export default ComplianceEvidenceTable;